import Crud from '@/views/Vacations/Crud'
import Entity from '@/views/Vacations/Entity'

const routes = {
  path: '/point-mirror',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/vacations/',
      name: 'list-vacations',
      component: Crud,
    },
    {
      path: '/vacations/add',
      name: 'Novo Registro de Férias',
      component: Entity,
    },
    {
      path: '/vacations/edit/:id?',
      name: 'Novo Registro de Férias',
      component: Entity,
    },
  ],
}

export default routes
